<script lang="ts" setup>
import MainLayout from '../components/layouts/MainLayout.vue'
import SaleWrap from '../components/sales/SaleWrap.vue'
</script>

<template>
  <MainLayout>
    <SaleWrap />
  </MainLayout>
</template>
